import React from "react";

const SyncToolsInstallations = () => {
    return <div>Sync Tools Installations</div>;
};

export default SyncToolsInstallations;
